import { useState } from "react";
import { Link } from "react-router-dom";
import { crmApi, formatApiError } from "@/orbit/lib/api";
import { Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await crmApi.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-8" data-testid="orbit-forgot-page">
      <div className="w-full max-w-sm">
        <div className="text-[11px] uppercase tracking-[0.22em] text-[#1E40AF] font-semibold">Orbit CRM</div>
        <h2 className="mt-3 text-2xl font-semibold text-[#0A1F44]">Reset your password</h2>
        <p className="mt-2 text-sm text-slate-500">Enter your email and we&apos;ll send a reset link (expires in 1 hour).</p>

        {sent ? (
          <div className="mt-8 bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-md p-4 text-sm" data-testid="orbit-forgot-sent">
            If an account exists for <strong>{email}</strong>, a reset link is on its way.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="orbit-forgot-form">
            <div>
              <label className="text-xs font-medium text-slate-700 uppercase tracking-wide">Work email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="orbit-forgot-email"
                className="mt-1.5 block w-full rounded-md border border-slate-300 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1E40AF]/40 focus:border-[#1E40AF]" />
            </div>
            {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md p-3">{error}</div>}
            <button type="submit" disabled={loading} data-testid="orbit-forgot-submit"
              className="w-full flex items-center justify-center gap-2 bg-[#0A1F44] text-white py-2.5 rounded-md text-sm font-semibold hover:bg-[#1E40AF] transition disabled:opacity-60">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Send reset link
            </button>
          </form>
        )}

        <p className="mt-6 text-sm text-slate-500">
          <Link to="/orbit/login" className="text-[#1E40AF] font-medium hover:underline" data-testid="orbit-back-to-login">
            ← Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
